/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { REGION_COUNTRY_MAPPING } from 'app/components/new-navigation/rankings/REPORT_CONFIG';
import { CountryRanking } from './CountryRanking';
import {
  Breakpoint,
  MediaQueryService
} from '../../../services/media-query.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-rankings-widget',
  templateUrl: './app-rankings.component.html',
  styleUrls: ['./app-rankings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppRankingsComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() type: string;
  @Input() os: string;
  @Input() category: string;
  @Input() date: string;
  @Input() isFreemium: boolean;

  limit = 10;
  rankings: Array<CountryRanking> = [];

  desktop$: Observable<boolean>;
  tablet$: Observable<boolean>;
  mobile$: Observable<boolean>;

  constructor(
    private _router: Router,
    private mediaQueryService: MediaQueryService
  ) {}

  ngOnInit() {
    this.desktop$ = this.mediaQueryService.gt(Breakpoint.md);
    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.mobile$ = this.mediaQueryService.lte(Breakpoint.md);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.rankings = this.transform(this.data);
    }
  }

  navigateRankings(rankingType: string, country: string) {
    const routerLink = [
      '/rankings',
      this.type,
      rankingType,
      this.os,
      this.category,
      this.getRegion(country),
      country,
      this.date + '01'
    ];
    void this._router.navigate(routerLink);
  }

  getRegion(country: string): string {
    let region = 'GLOBAL';
    if (country !== undefined) {
      for (const regionMap of REGION_COUNTRY_MAPPING) {
        if (regionMap.countries.indexOf(country) > -1) {
          region = regionMap.region;
          break;
        }
      }
    }
    return region;
  }

  toggleShowMore(ranking: CountryRanking) {
    ranking.showMore = !ranking.showMore;
  }

  transform(value: any): Array<CountryRanking> {
    const rankings: Array<CountryRanking> = [];
    if (value && value.reach) {
      // Reach Ranking
      const reachRanking: CountryRanking = {
        title: 'Global Reach Ranking by Country',
        tooltip: 'Reach Ranking by Country',
        showMore: true,
        rankingType: 'publisher-reach',
        countries: value.reach.map(item => {
          return {
            rank: item['mauRank'],
            rankChange: item['mauRankChange'],
            countryCode: item['countryCode'],
            countryName: item['countryName']
          };
        })
      };
      rankings.push(reachRanking);
    }

    if (value && value.marketShare) {
      // Market Share Ranking
      const marketShareRanking: CountryRanking = {
        title: 'Global Market Share Ranking by Country',
        tooltip: 'Market Share Ranking by Country',
        showMore: true,
        rankingType: 'publisher-grossing',
        countries: value.marketShare.map(item => {
          return {
            rank: item['impressionRank'],
            rankChange: item['impsRankChange'],
            countryCode: item['countryCode'],
            countryName: item['countryName']
          };
        })
      };
      rankings.push(marketShareRanking);
    }

    return rankings;
  }
}
